module.exports = __webpack_public_path__ + "img/logo-animated.3f45d6c4.svg";